import _ from 'lodash';
import { FaqDto } from '../../../interfaces/FaqDto';
import { FaqContent } from '../../../interfaces/FaqContent';
import { FaqFieldsDto } from '../../../interfaces/FaqFieldsDto';

export default function transformFaqData(faqData: FaqDto): FaqContent[] {
  const question = (faqFields: FaqFieldsDto[]) => faqFields.find((f) => f?.Name === 'Question')?.Value;
  const answer = (faqFields: FaqFieldsDto[]) => faqFields.find((f) => f?.Name === 'Answer')?.Value;

  const newFaqData: FaqContent[] = [];
  faqData?.value.forEach((f) => {
    newFaqData.push({
      question: question(f.Fields),
      answer: answer(f.Fields),
    });
  });

  return _.uniqWith(newFaqData, (a, b) => a.question === b.question && a.answer === b.answer);
}
